export class NetsServiceDashboard {
  public static ApiUrl = 'api/statistics-dashboard';

  TotalNumberOfNetsProduced: number | null;
  NetsProducedByDesign: NetsProducedByDesignDTO[];
  NetsProducedBySite: NetsProducedBySiteDTO[];

  TotalNumberOfNetsReceived: number | null;
  TotalNumberOfNetsDelivered: number | null;
  TotalNumberOfNetsUnderService: number | null;
  TotalNumberOfNetsScrapped: number | null;
  TotalNumberOfNetsWashed: number | null;
  TotalNumberOfNetsRepaired: number | null;
  TotalNumberOfNetsAntifouled: number | null;
  TotalNumberOfNetsWithExtendedLifespan: number | null;
  YearlyNetsServiceData: ServiceStatusYearlyStringCountDto[];

  TotalNumberOfSpecialProductsReceived: number | null;
  TotalNumberOfSpecialProductsDelivered: number | null;
  TotalNumberOfSpecialProductsUnderService: number | null;
  TotalNumberOfSpecialProductsScrapped: number | null;
  TotalNumberOfSpecialProductsWashed: number | null;
  TotalNumberOfSpecialProductsRepaired: number | null;
  YearlySpecialProductsServiceData: ServiceStatusYearlyStringCountDto[];

  TotalHoursUsedForRepairing: number | null;
  TotalHoursUsedForRepairingSpecialProduct: number | null;
  TotalImpregnationLiters: number | null;

  YearlyNetsRepairingData: NetsRepairingDto[];
  YearlyNetsImpregnationData: NetsImpregnationDto[];

  YearlyNetsDamageReportBySite: NetsDamagedBySiteDTO[];
  YearlyNetsDamageReportByCustomer: NetsDamagedByCustomerDTO[];
  AverageNetsDamageOneToThree: number | null;
  AverageNetsDamageFourToTen: number | null;
  AverageNetsDamageMoreThanTen: number | null;
  AverageNetsDamageBrokenLaces: number | null;
  AverageNetsDamageByLocation: NetDamageDataByLocation[];
}

export class NetsSalesDashboard {
  public static ApiUrl = 'api/statistics-dashboard';

  NumberOfNetOffersInProgress?: number;
  NumberOfNetOffersTransferredToOrder?: number;
  NumberOfNetOffersSignedContracts?: number;
  NumberOfNetOffersLostOrExpired?: number;
  TotalNumberOfOffers?: number;
  YearlySalesReportForCustomer: CustomerYearlySalesReportDTO[];
  YearlySalesReportForNetDesign: NetDesignYearlySalesReportDTO[];
  YearlyLostOffersReportForCustomer: CustomerYearlySalesReportDTO[];
  YearlyLostOffersReportForNetDesign: NetDesignYearlySalesReportDTO[];
  YearlySalesReportForCustomersWithoutSales: CustomerYearlySalesReportDTO[];
  YearlySalesReportForNetDesignWithoutSales: NetDesignYearlySalesReportDTO[];
}

export class CustomerSalesData {
  CustomerName: string;
  SalesYear: number;
  SalesCount: number;
  SalesDate: Date | null;
}

export class YearlySalesDTO {
  SalesYear: number;
  SalesCount: number;
}

export class CustomerYearlySalesReportDTO {
  CustomerName: string;
  YearlySales: YearlySalesDTO[];
}

export class NetDesignSalesData {
  NetDesign: string;
  SalesYear: number;
  SalesCount: number;
  SalesDate: Date | null;
}

export class NetDesignYearlySalesReportDTO {
  NetDesign: string;
  YearlySales: YearlySalesDTO[];
}

export class NetsSalesHistoryDto {
  CustomerName: string;
  LastSaleDate: Date | null;
  IntervalBetweenSales: number | null;
  AverageNetsInOrder: number | null;
  TotalSales: number | null;
  NumberOfOrders: number | null;
}

export class NetsSalesHistoryUngrouped {
  CustomerName: string;
  Created: Date | null;
}

export class NetsProducedByDesignDTO {
  NetDesign: string;
  YearlyProduction: YearlyProductionDTO[];
}

export class NetsProducedBySiteDTO {
  SiteName: string;
  YearlyProduction: YearlyProductionDTO[];
}

export class YearlyProductionDTO {
  ProductionYear: number;
  ProductionCount: number;
}

export class NetProductionDataByNetDesign {
  NetDesign: string;
  ProductionYear: number;
  ProductionCount: number;
  ProductionDate: Date | null;
}

export class NetProductionDataBySite {
  SiteName: string;
  ProductionYear: number;
  ProductionCount: number;
  ProductionDate: Date | null;
}

export class NetDamageDataBySite {
  SiteName: string;
  Year: number;
  DamageCount: number;
  DamageDate: Date | null;
}

export class NetsDamagedBySiteDTO {
  SiteName: string;
  YearlyDamage: YearlyDamageDTO[];
}

export class YearlyDamageDTO {
  Year: number;
  DamageCount: number;
}

export class NetDamageDataByCustomer {
  CustomerName: string;
  Year: number;
  DamageCount: number;
  DamageDate: Date | null;
}

export class NetsDamagedByCustomerDTO {
  CustomerName: string;
  YearlyDamage: YearlyDamageDTO[];
}

export class NetDamageData {
  Repairs1To3Msk: number;
  Repairs4To10Msk: number;
  RepairsOver10Msk: number;
}

export class NetDamageDataByLocation {
  ServiceRepairTypeId: number;
  LocationName: string;
  Repairs1To3Msk: number;
  Repairs4To10Msk: number;
  RepairsOver10Msk: number;
  BrokenLaces: number;
}

export class ServiceStatusCountDto {
  Year: number;
  QuarterlyData: QuarterlyServiceStatusCountDto[];
}

export class QuarterlyServiceStatusCountDto {
  Quarter: string;
  Count: number;
}

export class ServiceStatusYearlyCountDto {
  ServiceStatusId: number;
  ServiceStatusCounts: ServiceStatusCountDto[];
}

export class ServiceStatusYearlyStringCountDto {
  ServiceStatus: string;
  ServiceStatusCounts: ServiceStatusCountDto[];
}

export class NetsRepairingDto {
  Year: number;
  RepairingData: YearlyRepairingDto[];
}

export class YearlyRepairingDto {
  NetType: string;
  RepairingData: RepairingDto[];
}

export class RepairingDto {
  Hours: number | null;
  Count: number;
  AverageHours: number | null;
  DamageData: NetDamageData;
}

export class NetsImpregnationDto {
  Year: number;
  YearlyImpregnationData: YearlyImpregnationDto[];
}

export class YearlyImpregnationDto {
  NetType: string;
  ImpregnationData: ImpregnationDto[];
}

export class ImpregnationDto {
  ImpregnationType: string;
  Count: number;
  AverageAmount: number | null;
}
